import { Route, Routes } from "react-router-dom";
import Layout from "./pages/Layout";
import { Menu } from "./pages/Menu/Menu";
import Orders from "./pages/Orders";
import { useEffect, useState } from "react";
import { CartProvider } from "./Components/cart-context.js";
import { v4 as uuidv4 } from "uuid";

import "./styles/App.css";
import "./styles/cart.css";
import axios from "axios";

function App() {
  const params = new URLSearchParams(window.location.search);
  const branchToken = params.get("b");
  const [branchName, setBranchName] = useState("");
  const [MenuItems, setMenuItems] = useState([]);

  useEffect(() => {
    try {
      const token = localStorage.getItem("b");
      if (token !== null && branchToken && branchToken !== token) {
        localStorage.setItem("b", branchToken);
        const tracking_token = localStorage.getItem("tt");
        if (!tracking_token) {
          const n_tracking_token = uuidv4();
          localStorage.setItem("tt", n_tracking_token);
        }
        axios
          .get(`${process.env.REACT_APP_API_URL}/menu?b=${branchToken}`)
          .then((res) => {
            setBranchName(res.data.location);
            setMenuItems(res.data.data);
            document
              .getElementById("loading-wrapper")
              .classList.toggle("off", true);
          });
      } else if (!branchToken) {
        const savedToken = localStorage.getItem("b");
        if (savedToken) {
          axios
            .get(`${process.env.REACT_APP_API_URL}/menu?b=${savedToken}`)
            .then((res) => {
              const tt = localStorage.getItem("tt");
              if (!tt) {
                const new_tracking_token = uuidv4();
                localStorage.setItem("tt", new_tracking_token);
              }
              setBranchName(res.data.location);
              //console.log(res.data.data);
              setMenuItems(res.data.data);
              document
                .getElementById("loading-wrapper")
                .classList.toggle("off", true);
            });
        } else {
          alert("Please scan a valid QR code");
        }
      } else {
        axios
          .get(`${process.env.REACT_APP_API_URL}/menu?b=${branchToken}`)
          .then((res) => {
            localStorage.setItem("b", branchToken);
            const tt = localStorage.getItem("tt");
            if (!tt) {
              const new_tracking_token = uuidv4();
              localStorage.setItem("tt", new_tracking_token);
            }
            setBranchName(res.data.location);
            setMenuItems(res.data.data);
            document
              .getElementById("loading-wrapper")
              .classList.toggle("off", true);
          });
      }

      console.log("App Effect");
    } catch (err) {
      alert(err);
    }
  }, []);

  return (
    <>
      <CartProvider>
        <Routes>
          <Route path="/" element={<Layout branchName={branchName} />}>
            <Route index element={<Menu mu={MenuItems} />} />
            <Route path="history" element={<Orders />} />
          </Route>
        </Routes>
      </CartProvider>
    </>
  );
}

export default App;
